import { Route } from 'react-router-dom';
import { home } from 'routes/config';

import Worksheet from 'pages/Business/Agent/Worksheet';
import WorksheetForm from 'pages/Business/Agent/Worksheet/Components/WorksheetForm';
import CreateColumnForm from 'pages/Business/Agent/Worksheet/Components/CreateColumnForm';
import WorkflowForm from 'pages/Business/Agent/Worksheet/Components/WorkflowForm';
import ImportCsvForm from 'pages/Business/Agent/Worksheet/Components/ImportCsvForm';

export const worksheetRoutes = (
  <Route path={home.worksheets} element={<Worksheet />}>
    <Route path='add' element={<WorksheetForm />} />
    <Route path='add-workflow' element={<WorkflowForm />} />
    <Route path='add-column' element={<CreateColumnForm />} />
    <Route path=':worksheetId/edit' element={<WorksheetForm />} />
    <Route path=':worksheetId/import-csv' element={<ImportCsvForm />} />
  </Route>
);
